var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4C3.73122 4 2.5 5.23122 2.5 6.75V8H18.5V6.75C18.5 5.23122 17.2688 4 15.75 4H5.25ZM18.5 9H2.5V13.25C2.5 14.7688 3.73122 16 5.25 16H15.75C17.2688 16 18.5 14.7688 18.5 13.25V9ZM14 13H16C16.2761 13 16.5 13.2239 16.5 13.5C16.5 13.7761 16.2761 14 16 14H14C13.7239 14 13.5 13.7761 13.5 13.5C13.5 13.2239 13.7239 13 14 13Z",
    fill: "#696F8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.dd33d83c23b8bd7cd51b7e7f6ffb53e2.svg";
export { ForwardRef as ReactComponent };